export default "__VITE_ASSET__9832931a__"